import { memo } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Modal from 'ui/atoms/Modal';
import type { BasicDialogProps } from './types';

const Basic = ({
    actionsSlot,
    titleSlot,
    onClose,
    isCanClose = true,
    DialogProps = {},
    ...restProps
}: BasicDialogProps) => {
    const handleClose: BasicDialogProps['onClose'] = (...args) => {
        if (isCanClose) {
            onClose(...args);
        }
    };

    const renderTitleSlot = () =>
        titleSlot && (
            <Box
                sx={{
                    px: 1,
                    pr: 4
                }}
            >
                {titleSlot}
            </Box>
        );

    const renderActionsSlot = () =>
        actionsSlot && (
            <Stack
                direction='row'
                spacing={1}
                flexGrow={1}
                justifyContent={'flex-end'}
            >
                {actionsSlot}
            </Stack>
        );

    return (
        <Modal
            {...restProps}
            DialogProps={{
                ...DialogProps,
                sx: {
                    '& .MuiDialog-container .MuiPaper-root': {
                        maxWidth: '790px',
                        '& .MuiDialogContent-root' : {
                            borderBottom: 'none'
                        }
                    },
                    '& .MuiDialogActions-root': {
                        justifyContent: 'center'
                    },
                    ...(DialogProps.sx ?? {})
                }
            }}
            onClose={handleClose}
            titleSlot={renderTitleSlot()}
            actionsSlot={renderActionsSlot()}
        />
    );
};

export default memo(Basic);
